<template>
	<v-tab-item>
		<v-card flat>
			<h3 class="text-h6 font-weight-bold">依頼修正履歴</h3>
			<div class="table-container pa-2">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="fixLogs"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-sort
					disable-pagination
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item, index }">
						<tr class="no-click">
							<td
								v-for="(header, i) in headers"
								:key="i"
								:class="changedColumnClass(header, item, index)"
							>
								<p v-if="i == 0 && item[header.value] == null">変更{{ index }}</p>
								<p v-else v-text="item[header.value]" class="pre-wrap" />
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-card>
	</v-tab-item>
</template>

<script>
import common from "../../../../helper/common"

function initialHeaders() {
	return [
		{ value: "id", text: "項目", width: "120px" },
		{ value: "updated_at", text: "変更日", width: "180px" },
		{ value: "user_name", text: "変更者", width: "180px" },
		{ value: "reason", text: "変更理由", width: "200px" },
		{ value: "subtitle", text: "サブタイトル", width: "200px" },
		{ value: "deadline", text: "希望納期", width: "150px" },
		{ value: "message", text: "伝達事項", width: "200px" },
	]
}

export default {
	props: {
		requirement: {
			type: Object,
		},
	},
	data() {
		return {
			open: false,
			common: common,
			headers: initialHeaders(),
			fixLogs: [],
		}
	},
	mounted() {
		this.setFixes()
	},
	methods: {
		setFixes() {
			this.headers = initialHeaders()
			if (this.requirement.requirement_type.need_matter_flag) {
				this.headers = this.headers.concat([
					{ value: "matter_id", text: "案件", width: "200px" },
					{ value: "matter_product_id", text: "見積製品", width: "200px" },
					{ value: "ordered_product_id", text: "受注製品(製番)", width: "200px" },
					{ value: "order_individual_info_id", text: "受注製品(枝番)", width: "200px" },
				])
			}

			let fixLogs = this.requirement.requirement_fixes?.map((fix) => {
				let fixLog = {
					updated_at: common.formatDateTime(fix.updated_at),
					reason: fix.reason,
					user_name: fix.user?.full_name,
				}
				if (fix.changed_column == "deadline") {
					fixLog.deadline = common.formatDate(fix.deadline)
				} else if (fix.changed_column.includes("matter_id")) {
					fixLog.matter_id = common.returnMatterInfo(fix.matter)
					fixLog.matter_product_id = common.matterProductByRequirement(fix)
					fixLog.ordered_product_id = common.orderedProductByRequirement(fix)
				} else if (fix.changed_column.includes("matter_product_id")) {
					fixLog.matter_product_id = common.matterProductByRequirement(fix)
					fixLog.order_individual_info_id = common.orderIndividualInfoByRequirement(fix)
				} else if (fix.changed_column.includes("ordered_product_id")) {
					fixLog.ordered_product_id = common.orderedProductByRequirement(fix)
					fixLog.order_individual_info_id = common.orderIndividualInfoByRequirement(fix)
				} else if (fix.changed_column.includes("order_individual_info_id")) {
					fixLog.order_individual_info_id = common.orderIndividualInfoByRequirement(fix)
				} else {
					fixLog[fix.changed_column] = fix[fix.changed_column]
				}
				return fixLog
			})

			this.requirement.requirement_type.requirement_columns?.forEach((c) => {
				this.headers.push({
					value: `value-${c.id}`,
					text: c.name,
					width: "200px",
				})
				const fixes = this.valueByColumn(c)?.requirement_value_fixes
				fixes?.forEach((fix) =>
					fixLogs.push({
						updated_at: common.formatDateTime(fix.updated_at),
						reason: fix.reason,
						user_name: fix.user?.full_name,
						[`value-${c.id}`]: common.value(c, fix.value),
					})
				)
			})
			this.fixLogs = fixLogs.sort((a, b) => {
				return a.updated_at < b.updated_at ? 1 : -1
			})
			const requirement = {
				id: "現在の値",
				created_at: common.formatDateTime(this.requirement.created_at),
				subtitle: this.requirement.subtitle,
				message: this.requirement.message,
				user_name: this.requirement.user.full_name,
				deadline: common.formatDate(this.requirement.deadline),
				matter_id: common.returnMatterInfo(this.requirement.matter),
				matter_product_id: common.matterProductByRequirement(this.requirement),
				ordered_product_id: common.orderedProductByRequirement(this.requirement),
				order_individual_info_id: common.orderIndividualInfoByRequirement(this.requirement),
			}
			this.requirement.requirement_type.requirement_columns?.forEach((c) => {
				requirement[`value-${c.id}`] = common.value(c, this.valueByColumn(c)?.value)
			})
			this.fixLogs.unshift(requirement)
		},
		changedColumnClass(header, item, i) {
			if (
				header.value == "updated_at" ||
				header.value == "user_name" ||
				header.value == "reason" ||
				header.value == "item" ||
				i == 0
			)
				return null
			if (item[header.value] || item[header.value] === "") return "changed-data"
		},
		valueByColumn(c) {
			return this.requirement.requirement_values.find((v) => v.requirement_column_id == c.id)
		},
	},
	watch: {
		requirement: {
			handler(newVal, _) {
				this.requirement = newVal
				this.setFixes()
			},
		},
		immediate: true,
		deep: true,
	},
}
</script>

<style lang="scss" scoped>
.show-dialog-table {
	td,
	th {
		width: 300px;
	}
}
.changed-data {
	background-color: whitesmoke;
}
</style>